import * as React from 'react';
import { Attribute } from '../../product';
import Select from './Select';
import { Text } from './Text';
import VariantAttributesListItem from './VariantAttributesListItem';

const VariantOptions: string[] = ['Grind Size', 'Gift Wrapping', 'Size'];

const arrToOpts = (opts: string[]) =>
  opts.map((val: string) => ({
    label: val,
    value: val,
  }));

export interface Props {
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: Attribute[];
}

const addToArray = (value: Attribute[], newValue: Attribute) => {
  return Array.from(new Set(value.concat([newValue])));
};

export default function VariantAttributes({
  label,
  tooltip,
  field,
  onValueChange,
  defaultValue = [],
}: Props) {
  const [name, setName] = React.useState<string>(null);
  const [options, setOptions] = React.useState<string[]>([]);
  const nameRef = React.useRef(null);
  const canAdd = name && options;

  const onAdd = () => {
    if (!options || !name) {
      return;
    }

    onValueChange(field, addToArray(defaultValue, { name, options }));
    nameRef.current.value = null;
  };

  const setAttributeValue = (index: number) => (newAttribute: Attribute) => {
    const newCopy: Attribute[] = defaultValue.slice();
    newCopy[index] = newAttribute;

    onValueChange(field, newCopy);
  };

  const onDelete = (index: number) => {
    onValueChange(
      field,
      defaultValue.filter((_, another: number) => another !== index),
    );
  };

  return (
    <div className="mb3">
      <div className="flex flex-column">
        {defaultValue.map((item: Attribute, index: number) => (
          <VariantAttributesListItem
            attribute={item}
            setAttribute={setAttributeValue(index)}
            onDelete={() => onDelete(index)}
          />
        ))}
      </div>
      <div className="relative mv3 flex">
        <div className="mr3 flex-auto">
          <Select
            label="Name"
            field={['name']}
            id={'name'}
            defaultValue={name}
            onValueChange={(_: any, newName: string) => setName(newName)}
            options={arrToOpts(VariantOptions.concat(['Other…']))}
          />
          {!VariantOptions.includes(name) && name ? (
            <Text
              label="Enter a value…"
              field={['name']}
              id={'custom-name'}
              defaultValue={name}
              onValueChange={(_: any, newName: string) => setName(newName)}
              placeholder="Name i.e. 'Gift Wrapping'"
            />
          ) : null}
        </div>
        <button
          disabled={!canAdd}
          type="button"
          className={`${
            canAdd ? 'gold dim pointer' : 'white-20'
          } b dib link bg-transparent bw0 pa3 w3`}
          onClick={onAdd}
        >
          Add
        </button>
      </div>
    </div>
  );
}
